import useEdgeQuery from '@app/data/edge/hooks/useEdgeQuery';
import { GET_USER_GENERATED_CONTENT_COLLECTION } from '../queries/GetUserGeneratedContentCollection';

type Props = {
  collection: string;
};

const useUserGeneratedContentCollection = ({ collection }: Props) =>
  useEdgeQuery(GET_USER_GENERATED_CONTENT_COLLECTION, {
    variables: {
      id: collection,
    },
    enabled: !!collection,
    select: (data) => data?.userGeneratedContentCollection ?? null,
  });

export default useUserGeneratedContentCollection;
